<template>
  <div id="masonry-gallery"
    :class="['organism gallery-grid', 'container-' + organism.containerWidth, organism.removeMargin]"
    
  >
    <ul
      class="px-4 mx-auto mb-16 grid grid-cols-3 md:grid-cols-4 gap-4 max-w-7xl"
    >
      <li
        v-for="(item, index) in gallery"
        :class="[
          index >= thumbnailCount ? 'hidden' : '',
          'index-' + index,
          '[&:nth-child(7n-6)]:col-span-2 [&:nth-child(7n-6)]:row-span-2 max-h-[200px] [&:nth-child(7n-6)]:max-h-[416px] bg-gray-600 relative',
        ]"
      >
        <button
          @click="modalImageSlider.openModal(index)"
          class="w-full h-full group"
        >
          <img
            class="object-cover w-full h-full group-hover:opacity-50 transition-opacity"
            v-bind="useResponsiveImage(item.imageThumbnailImage, 'large')"
          />
          <div
            class="absolute inset-0 items-center justify-center hidden group-hover:flex"
          >
            <i class="block text-5xl text-white icon icon-zoom-in"></i>
          </div>
        </button>
      </li>
    </ul>
    <OrganismsModalImageSlider />
  </div>
</template>

<style>
.gallery-grid {
}
</style>

<script setup>
import { storeToRefs } from "pinia";
const modalImageSlider = useModalImageSlider();
const { sliderImages } = storeToRefs(modalImageSlider);
const props = defineProps({
  organism: Object,
});

const thumbnailCount = computed(() => {
  return props.organism.thumbnailCount ? props.organism.thumbnailCount : 10;
});

const gallery = computed(() => {
  const images = props?.organism?.gallery?.map((item) => {
    return {
      imageThumbnailSrc: getImageSrc(item, "large"),
      imageThumbnailImage: item,
      imageFullSrc: item?.sourceUrl,
      alt: item?.altText,
    };
  });
  sliderImages.value = images;
  return images;
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
